<template>
  <div>
    <PageAllow controller="FoodCategories" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <v-text-field
              v-model="dishCategoriesSearch"
              :label="$t('DishCategory.dishCategoriesKeyword')"
              clearable
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="getDishCategries()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="dishCategoriesSearch = ''"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-spacer />
            <v-btn
              small
              color="primary"
              @click.stop="
                currentItem = { id: 0 };
                editDialog = true;
              "
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.newInfo", [$t("DishCategory.ObjectName")]) }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="mx-4 mb-4">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-btn text x-large color="primary" @click.stop="openAll = !openAll">
          {{ $t("openAll") }} / {{ $t("closeAll") }}
        </v-btn>
        <v-divider />
        <v-treeview
          class="py-2"
          v-model="tree"
          :items="dishCategries"
          :search="dishCategoriesSearch"
          :filter="categoriesFilter"
          :active.sync="dishCategoriesSelected"
          item-key="name"
          item-children="categories"
          :open-all="openAll"
          hoverable
          activatable
          return-object
          :open.sync="categoriesOpen"
        >
          <template v-slot:label="{ item }">
            <v-chip> {{ item.code }} </v-chip>
            {{ item.name }}

            <v-icon
              small
              color="primary"
              class="px-1 py-4 me-1"
              @click.stop="
                currentItem = JSON.parse(JSON.stringify(item));
                editDialog = true;
              "
              >fa-pencil-alt
            </v-icon>
            <v-icon
              small
              color="primary"
              class="px-1 py-4 me-1"
              @click.stop="
                currentItem = {
                  parent_id: item.id,
                  parent_number: item.code,
                  parent_name: item.name,
                };
                editDialog = true;
              "
              >fa-plus
            </v-icon>
            <v-icon
              small
              v-if="item.actions && item.actions.delete"
              color="accent"
              class="px-1 py-4 me-1"
              @click.stop="
                currentItem = JSON.parse(JSON.stringify(item));
                deleteDialog = true;
              "
              >fa-trash-alt
            </v-icon>
          </template>
        </v-treeview>
      </v-card>
    </v-sheet>

    <v-dialog persistent v-model="editDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("DishCategory.ObjectNameInfo") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("DishCategory.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-form>
                <v-row>
                  <v-col
                    cols="12"
                    v-if="currentItem.parent_id && !currentItem.id"
                  >
                    <v-text-field
                      required
                      readonly
                      :label="$t('DishCategory.Fields.parent_number_and_name')"
                      :value="
                        currentItem.parent_number +
                        ' / ' +
                        currentItem.parent_name
                      "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('DishCategory.Fields.dish_category_code')"
                      rules="required"
                    >
                      <v-text-field
                        required
                        v-model="currentItem.code"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'code')
                            .concat(errors)
                        "
                      >
                        <template v-slot:label>
                          {{ $t("DishCategory.Fields.dish_category_code") }}
                          <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('DishCategory.Fields.dish_category_name')"
                      rules="required"
                    >
                      <v-text-field
                        required
                        v-model="currentItem.name"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:label>
                          {{ $t("DishCategory.Fields.dish_category_name") }}
                          <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="editDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="save()">{{ $t("CRUD.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('DishCategory.ObjectName')"
      @confirm="
        del();
        deleteDialog = false;
      "
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DishCategories from "@/api/dish_categories";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import DialogDelete from "@/components/plugins/DialogDelete";

setInteractionMode("eager");

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ValidationProvider,
    ValidationObserver,
    DialogDelete,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.dishManagement"),
        disabled: false,
        href: "/dishes",
      },
      {
        text: i18n.t("Nav.dishCategories"),
        disabled: true,
        href: "/dish-categories",
      },
    ],
    categoriesFilter() {
      return (item, search) =>
        item.name.indexOf(search) > -1 || item.code.indexOf(search) > -1;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    menu: false,
    dishCategoriesSearch: "",
    dishCategoriesSelected: [],
    categoriesOpen: [],
    tree: [],
    dishCategries: [],
    serverErrors: [],
    openAll: false,
    currentItem: {},
    editDialog: false,
    deleteDialog: false,
  }),

  mounted() {
    this.getDishCategriesFromAPI();
  },

  methods: {
    openTree(openArr) {
      for (var i = 0; i < openArr.length; i++) {
        this.categoriesOpen.push(openArr[i]);
        if (openArr[i].categories.length > 0) {
          this.openTree(openArr[i].categories);
        }
      }
    },
    getDishCategriesFromAPI() {
      DishCategories.tree().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.dishCategries = response.data.categories;
          }
        }.bind(this)
      );
    },
    save() {
      this.serverErrors = [];
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            this.$store.dispatch("fullscreenLoading");
            DishCategories.save(this.currentItem.id, this.currentItem)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.currentItem);
                    this.getDishCategriesFromAPI();
                    this.editDialog = false;
                    this.$store.dispatch("fullscreenLoadingStop");
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                    this.$store.dispatch("fullscreenLoadingStop");
                  }
                }.bind(this)
              )
              .catch(
                function () {
                  this.editDialog = false;
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          }
        }.bind(this)
      );
    },
    del() {
      DishCategories.del(this.currentItem.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getDishCategriesFromAPI();
          }
        }.bind(this)
      );
    },
  },

  watch: {
    openAll: {
      handler() {
        if (this.openAll) {
          this.openTree(this.dishCategries);
        } else {
          this.categoriesOpen = [];
        }
      },
    },
    editDialog: {
      handler() {
        if (!this.editDialog) {
          this.$refs.observer.reset();
          this.serverErrors = [];
          this.$store.dispatch("fullscreenLoadingStop");
        }
      },
    },
  },
};
</script>